import script from "./TagsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsView.vue?vue&type=script&setup=true&lang=js"

import "./TagsView.vue?vue&type=style&index=0&id=198e3cda&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198e3cda"]])

export default __exports__